import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Style from 'app/components/VideoPlayerGlobal/components/Endcard/Endcard.module.scss';

const GenericEndcard = ({ action, background, cta, header }) => (
  <div className={Style.endcard}>
    <img className={Style.background} src={background} alt="" />
    <div className={Style.endcardContainer}>
      <div className={Style.endcardHeader}>{header}</div>
      <Link className={Style.endcardCta} onClick={action}>
        {cta}
      </Link>
    </div>
  </div>
);

export default GenericEndcard;

GenericEndcard.propTypes = {
  action: PropTypes.func.isRequired,
  background: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
};
